import { OnboardingCitizenship } from 'modules/onboarding/common/components';

import { useCitizenship } from '../hooks';
import { PageComponentProps } from '../types';

export const CitizenshipStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    goToBack,
    initialValues,
    onSubmit,
    submitLoading,
  } = useCitizenship();

  return (
    <OnboardingCitizenship
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
